/*eslint-disable react/no-set-state*/
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import * as accountActions from '../../actions/accountActions';
import '../../styles/dashboard/dashboardPage.css';
import DashboardOptions from './DashBoardOptions';
import DashboardHeading from './DashboardHeading';
import * as pathConstants from '../../constants/pathConstants';
import SubmissionStatusData from './SubmissionStatusData'; //eslint-disable-line import/no-named-as-default

export class DashboardPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      establishments: this.props.establishments,
      user: this.props.user,
    };
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.redirect = this.redirect.bind(this);
  }

  componentDidMount() {
    if (this.state.establishments.length === 0) {
      this.props.accountActions.getAllEstablishments();
    }
    const requiredFields = ["firstName", "lastName"];
    const profile_errors = [];
    if (this.state.user != null) {
      const user = this.state.user[this.state.user.length - 1];
      if (user) {
        for (const field of requiredFields) {
          if (user[field] == null) {
            profile_errors.push(`${field} is required.`);
          }
        }
      }
      if (profile_errors != null) {
        // Needs profile update.
        if (profile_errors.length > 0) {
          console.log("User needs to update profile");
          const pathToEditProfile = pathConstants.pathToAccountEditPage + '?update_required=true';
          this.redirect(pathToEditProfile);
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.establishments !== this.props.establishments) {
      this.setState({ establishments: nextProps.establishments });
    }
  }
  handleButtonClick(event) {
    event.preventDefault();
    const path = event.target.name;
    this.redirect(path);
  }

  redirect(path) {
    browserHistory.push(path);
  }


  render() {
    let establishmentsActive = this.props.establishments
      .filter(establishment => establishment.establishment_status == 1);
    let numNoEin = establishmentsActive
      .filter(establishment => establishment.ein.ein == null)
      .length;
    if (numNoEin > 0 && sessionStorage.getItem('onLogin') === '1') {
      this.setState({ showEinModal: true });
      sessionStorage.setItem('onLogin', '2');
    }
    return (
      <div className="dashboard-with-modal">
        <div className="dashboard-container">
          {this.props.user && <DashboardHeading user={this.props.user} />}
          <div className="row">
            <div className="instruction-graphic col-sm-6 col-xs-12 right-homepage">
              <div className="graphic-instructions">
                <h3 alt="Overview of Data Submission Process">
                  Overview of Data Submission Process
                </h3>
                <img src={require('../../images/step-graphic-new.svg')} id="home-step-graphic" alt="Step 1: Create an Establishment; Step 2: Add 300A Summary Data,Step 2a: Add 300/301 Data (if required), Step 3: Submit Data to OSHA, Step 4: Review Confirmation Email." />
                <div className="mobile-step-graphic">
                  <div className="step-one">
                    <span className="step-text">
                      Step 1:
                    </span>
                    Create an Establishment
                  </div>
                  <div className="step-two">
                    <span className="step-text">
                      Step 2:
                    </span>Add 300A Summary Data
                  </div>
                  <div className="step-three">
                    <span className="step-text">
                      Step 2a:
                    </span>Add Case Data (if required)
                  </div>
                  <div className="step-four">
                    <span className="step-text">
                      Step 3:</span>
                    Submit Data to OSHA
                  </div>
                  <div className="step-five">
                    <span className="step-text">
                      Step 4:
                    </span>
                    Review Confirmation Email
                  </div>
                </div>
              </div>
            </div>
            <DashboardOptions errors={this.props.errors} onClick={this.handleButtonClick} />
            <div className="col-sm-6 col-xs-12 right-homepage">
            {this.props.establishments && this.props.establishments.length > 0 ? (
                <SubmissionStatusData establishments={this.props.establishments} />
              ) : (
                <div>&nbsp;</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardPage.propTypes = {
  accountActions: PropTypes.object.isRequired,
  user: PropTypes.object,
  userObject: PropTypes.object.isRequired,
  establishments: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  const user = state.user[state.user.length - 1];
  let authenticated = state.login[state.login.length - 1].authenticated;
  let errors = [];
  let establishments = [];
  const login = state.login[state.login.length - 1];
  const userObject = {
    username: login.username,
    password: login.password
  };

  if (state.establishments && state.establishments.length !== 0) {
    establishments = state.establishments
      .filter((establishment) => {
        return (establishment.establishment_status == 1);
      });
  }
  if (state.errors && state.errors.length > 0) {
    errors = state.errors;
  }
  return { user, authenticated, userObject, establishments, errors };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashboardPage.js
 **/